import { MainFilterType } from "./filter-type";

export const initialMainFilters: Record<MainFilterType, boolean> = {
  [MainFilterType.Comment]: false,
  [MainFilterType.SystemLog]: false,
};


export function createInitialMainFilters(
  userGroups: string[]
): Record<MainFilterType, boolean> {
  if (
    userGroups.any((group) =>
      [
        "crm-group-hba",
        "crm-group-oc-staffing",
        "crm-group-bemanningskoordinator"
      ].includes(group)
    )
  ) {
    return {
      [MainFilterType.Comment]: true,
      [MainFilterType.SystemLog]: true,
    };
  }

  return initialMainFilters;
}
